import React, { useEffect, useState } from "react";
import "./searchingTag.scss";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  LinearProgress,
  TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import searchTagStore from "../../../stores/searchTagStore";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../../components/customNoRowsOverlay/CustomNoRowsOverlay";

// Icons
import { IoIosAdd } from "react-icons/io";
import EditIcon from "@mui/icons-material/Edit";
import IOSSwitch from "../../../components/iosSwitch/IOSSwitch";

const SearchingTag = () => {
  const SearchTagStore = searchTagStore();
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(null);

  const columns = [
    // {
    //   field: "_id",
    //   headerName: "ID",
    //   flex: 0.51,
    //   renderCell: (params) => {
    //     return (
    //       params.api.getRowIndexRelativeToVisibleRows(params.row._id) !==
    //         undefined && (
    //         <p>
    //           {1 + params.api.getRowIndexRelativeToVisibleRows(params.row._id)}
    //         </p>
    //       )
    //     );
    //   },
    // },
    { field: "tag", headerName: "Tag", flex: 1 },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: (params) => {
        if (params.row._id === statusLoading) {
          return [<LoadingButton loading></LoadingButton>];
        }
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={() => {
              SearchTagStore.fillUpdateData({
                _id: params.row._id,
                tag: params.row.tag,
              });
              setOpenDialog(true);
            }}
            color="inherit"
          />,

          <IOSSwitch
            checked={params.row && params.row.status}
            onClick={() => {}}
            sx={{ m: 1 }}
            onChange={async (e) => {
              setStatusLoading(params.row._id);
              await SearchTagStore.updateSearchTagStatus({
                _id: params.row._id,
                status: e.target.checked,
              });
              setStatusLoading(null);
            }}
          />,
        ];
      },
    },
  ];

  const handleClick = async () => {
    setLoading(true);
    if (SearchTagStore._id) {
      await SearchTagStore.updateSearchTag();
    } else {
      await SearchTagStore.createSearchTag();
    }
    setLoading(false);
    handleClose();
  };

  const handleClose = () => {
    setOpenDialog(false);
    SearchTagStore.clearData();
  };

  useEffect(() => {
    SearchTagStore.fetchAllSearchTag();
  }, []);
  return (
    <div className="searchingTag">
      <Grid container>
        <h2 className="title">Searching Tag</h2>
      </Grid>
      <div className="btn-right-side flex m-10">
        <Button
          className="btn"
          variant="contained"
          startIcon={<IoIosAdd />}
          onClick={() => setOpenDialog(true)}
        >
          New Tag
        </Button>
      </div>
      <div className="add-tag-dialog">
        <Dialog open={openDialog} onClose={handleClose} className="dialog">
          <DialogTitle>
            {SearchTagStore._id ? "Edit " : "Create "}
            Search Tag
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              To provide better experience for searching to create accurate tag
              name.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              name="tag"
              label="Tag"
              type="text"
              fullWidth
              value={SearchTagStore.tag}
              variant="standard"
              onChange={(e) => {
                const { name, value } = e.target;
                SearchTagStore.writeData({ name, value });
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <LoadingButton loading={loading} onClick={handleClick}>
              {SearchTagStore._id ? "Save Changes" : "Create "}
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </div>
      <div className="display-tag-table">
        <DataGrid
          autoHeight
          getRowId={(row) => row._id}
          rows={
            SearchTagStore.searchTags
              ? SearchTagStore.searchTags.slice(0).reverse()
              : []
          }
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 5 },
            },
          }}
          loading={SearchTagStore.searchTags ? false : true}
          density="standard"
          slots={{
            // toolbar: GridToolbar,
            loadingOverlay: LinearProgress,
            noRowsOverlay: CustomNoRowsOverlay,
          }}
          pageSizeOptions={[5, 10]}
          // checkboxSelection
        />
      </div>
    </div>
  );
};

export default SearchingTag;
